var map = {
	"./destination-01.jpg": 67360,
	"./destination-02.jpg": 64623,
	"./destination-03.jpg": 8594,
	"./destination-04.jpg": 34081,
	"./gallery-1.jpg": 81586,
	"./gallery-2.jpg": 91485,
	"./gallery-3.jpg": 40352,
	"./gallery-4.jpg": 23187,
	"./recommand-01.jpg": 18662,
	"./recommand-02.jpg": 50865,
	"./recommand-03.jpg": 62708,
	"./recommand-04.jpg": 57343
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73330;